import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Why don’t I prioritise my
                                                tasks?
                                            </div>
                                            <p>From reading through the previous sections you will probably
                                                realise that prioritising tasks is not
                                                complex, and yet there are many courses available to help
                                                people learn to prioritise and manage
                                                their time more effectively. In fact, a recent review of
                                                academic studies of time management
                                                training has concluded:</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpadnew uiheading lightbgcenter">
                                                <p>Time management behaviours relate positively to perceived
                                                    control of time, job satisfaction,
                                                    and health, and negatively to stress. Time management
                                                    training seems to enhance time
                                                    management skills, but this does not automatically
                                                    transfer to better performance.<a
                                                        className="superscripttext"
                                                        href="further_info.php?course=300"><sup>2</sup></a>
                                                </p>
                                            </div>
                                            <p style={{paddingTop:'15px !important'}}>The research points out
                                                the many benefits of being able to manage time effectively,
                                                which include
                                                job satisfaction and reduced stress – but achieving these
                                                benefits doesn’t seem so easy! Whilst
                                                the skills required to prioritise tasks can be learned,
                                                there can be hindrances, or ‘blockers’ to
                                                employing them.</p>
                                            <p>Blockers can be related to our personalities and, therefore,
                                                will differ from person to person.
                                                Below are some different profiles of people who will find it
                                                hard to prioritise.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpadnew lightbgcenter">
                                                <div className="border_subtitle">Can’t say no</div>
                                                <p>This person cannot say ‘no’ when asked to do a task. They
                                                    feel they will be letting people
                                                    down if they explain they can’t do something in the time
                                                    allowed. This person thinks they
                                                    are not doing a good job unless they do all they are
                                                    asked to.</p>
                                                <div className="border_subtitle">Starter but not completer
                                                </div>
                                                <p>This person enjoys starting new tasks.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>3</sup></a> &nbsp;They
                                                    get a kick from making some initial early
                                                    progress, then relax with an assumption that they can
                                                    finish the task quickly. So reassured,
                                                    they start the next task.</p>
                                                <div className="border_subtitle">The optimist</div>
                                                <p>This person underestimates the time needed to complete
                                                    tasks and overestimates their
                                                    capacity for work generally.</p>
                                                <div className="border_subtitle">The perfectionist</div>
                                                <p>This person has a need to do all tasks to the best of
                                                    their ability. So concerned with getting
                                                    tasks right, they fail to see the importance of each
                                                    task and over-commit.</p>
                                                <div className="border_subtitle">Not enough time to set
                                                    priorities
                                                </div>
                                                <div className="uiheading"><p>This person does not have the
                                                    luxury of spending time planning and prioritising. They
                                                    have
                                                    so many deadlines they don’t have time for anything but
                                                    work.</p></div>
                                            </div>

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>WHAT TYPE AM I?
                                            </div>
                                            <p>Look at these ‘blocker’ profiles and consider which type you
                                                might be. You might even come up
                                                with a different type of your own. To do this effectively
                                                you need to think in depth about occasions
                                                when you have failed to prioritise your tasks effectively
                                                and, as a result, failed to meet a deadline.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page6')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}